import {LaunchBetbyResponse, LaunchUrl, SabaPlatform} from "../http/protocol";
import {HttpService} from "../http/HttpService";


export class SportsbookService {
    constructor(private http : HttpService) {}

    getSong88GameLaunchUrl(currency:string, locale : string) : Promise<LaunchUrl>{
        return this.http.get("/sportsbook/song88/launch/"+currency+"/" + locale);
    }

    getSong88AnonymousGameLaunchUrl(currency:string, locale : string) : Promise<LaunchUrl>{
        return this.http.get("/sportsbook/song88/launch-anonymous/"+currency+"/" + locale);
    }

    getUltraplayGameLaunchUrl(currency:string, locale : string, mobile: boolean = false) : Promise<LaunchUrl>{
        return this.http.get(`/sportsbook/ultraplay/launch/${currency}/${locale}?mobile=${mobile}`);
    }

    getUltraplayAnonymousGameLaunchUrl(locale : string, mobile: boolean = false) : Promise<LaunchUrl>{
        return this.http.get(`/sportsbook/ultraplay/launch-anonymous/${locale}?mobile=${mobile}`);
    }

    toSabaPlatform(mobile?: boolean) {
        return "platform=" + (mobile ? SabaPlatform.MOBILE : SabaPlatform.DESKTOP);
    }

    getSabaGameLaunchUrl(currency:string, locale : string, mobile? : boolean) : Promise<LaunchUrl>{
        return this.http.get("/sportsbook/saba/launch/"+currency+"/" + locale + "?" + this.toSabaPlatform(mobile));
    }

    getSabaAnonymousGameLaunchUrl(locale : string, mobile?: boolean) : Promise<LaunchUrl>{
        return this.http.get("/sportsbook/saba/launch-anonymous/" + locale + "?" + this.toSabaPlatform(mobile));
    }

    getBetbyGameLaunchUrl(locale:string, currency : string) : Promise<LaunchBetbyResponse>{
        return this.http.get("/sportsbook/betby/launch/" + currency + "/" + locale);
    }

    getBetbyAnonymousGameLaunchUrl() : Promise<LaunchBetbyResponse>{
        return this.http.get("/sportsbook/betby/launch-anonymous");
    }

}



